module.exports = __webpack_public_path__ + "static/media/06.1f01f156.jpg";